<template>
  <transition name="fade">
    <div class="preloader">
      <div class="preloader__circle"></div>
    </div>
  </transition>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>
